import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import axios, { API } from "@/lib/apiClient";
import { toast } from "sonner";

export const Admin = () => {
  const { user } = useAuth();
  const [rescanHours, setRescanHours] = useState(168);
  const [digestHours, setDigestHours] = useState(168);
  const [legalTeamPhone, setLegalTeamPhone] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/settings`).then((res) => {
      setRescanHours(res.data.rescan_interval_hours);
      setDigestHours(res.data.digest_interval_hours);
      setLegalTeamPhone(res.data.legal_team_phone || "");
    }).catch(() => {});
  }, []);

  if (user && user.role !== "admin") {
    return <p className="p-10 text-center text-sovereign" data-testid="admin-forbidden">Admin access only.</p>;
  }

  const save = async () => {
    setLoading(true);
    try {
      await axios.put(`${API}/admin/settings`, {
        rescan_interval_hours: Number(rescanHours),
        digest_interval_hours: Number(digestHours),
        legal_team_phone: legalTeamPhone.trim() || null,
      });
      toast.success("Settings updated.");
    } catch (err) {
      toast.error("Could not update settings.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-16" data-testid="admin-page">
      <h1 className="mb-6 font-heading text-2xl font-bold text-white">Admin Settings</h1>
      <label className="mb-2 block text-sm text-slate-400">Auto Re-Scan interval (hours)</label>
      <Input
        type="number"
        min={1}
        max={720}
        value={rescanHours}
        onChange={(e) => setRescanHours(e.target.value)}
        className="mb-4 border-surface-border bg-obsidian text-white"
        data-testid="admin-rescan-interval-input"
      />
      <label className="mb-2 block text-sm text-slate-400">Weekly Signal Digest interval (hours)</label>
      <Input
        type="number"
        min={1}
        max={720}
        value={digestHours}
        onChange={(e) => setDigestHours(e.target.value)}
        className="mb-4 border-surface-border bg-obsidian text-white"
        data-testid="admin-digest-interval-input"
      />
      <label className="mb-2 block text-sm text-slate-400">Legal Team Phone (Sovereign Alert SMS)</label>
      <Input
        type="tel"
        placeholder="+1..."
        value={legalTeamPhone}
        onChange={(e) => setLegalTeamPhone(e.target.value)}
        className="mb-4 border-surface-border bg-obsidian text-white"
        data-testid="admin-legal-team-phone-input"
      />
      <Button onClick={save} disabled={loading} className="bg-sovereign text-white hover:bg-sovereign/90" data-testid="admin-save-settings-btn">
        {loading ? "Saving..." : "Save"}
      </Button>
    </div>
  );
};
